import { render, staticRenderFns } from "./feedforward-detail.vue?vue&type=template&id=0d4ceaf4&scoped=true&"
import script from "./feedforward-detail.vue?vue&type=script&lang=js&"
export * from "./feedforward-detail.vue?vue&type=script&lang=js&"
import style0 from "./feedforward-detail.vue?vue&type=style&index=0&id=0d4ceaf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ceaf4",
  null
  
)

export default component.exports